import { useEffect, useState } from "react"
import { Collapse, Navbar } from "react-bootstrap"
import { Link, useLocation } from "react-router"
import { useAppSelector } from "../../../services/hooks"
import { Categories } from "../../../stores/categories/categories"

type ShowMenuRecurringArguments = {
    defineTopLevel: Categories // pierwszy/następny poziom obiektów menu
    urlSegment?: string // argument niezbędny do budowania ściezki do linku w rekurencji
    padding?: string // argument budujący wcięcie w rekurencji
    menuOpenId?: string // argument budujący zagnieżdzone ID, czyli rodzic ma .1 to dziecko ma np .1.4 - cyfry to IdCategori z backendu
}

export default function MenuCategories() {
    const location = useLocation()
    const menuContent = useAppSelector((state) => state.categories.data)
    const loaded = useAppSelector((state) => state.categories.loaded)
    const [menuOpen, setMenuOpen] = useState<{ [key: string]: { state: boolean, slug: string } }>({}) //TODO przerobić na dispatch/reducer albo nie

    useEffect(() => {
        if (!loaded || !menuContent.length) return;           // czekaj aż dane będą gotowe

        // 1. budujemy pełną mapę kluczy menu
        const map: Record<string, { state: boolean; slug: string }> = {};

        const build = (list: Categories, prefix = '') => {
            list.forEach(c => {
                const key = prefix ? `${prefix}.${c.categoryId}` : `.${c.categoryId}`;
                map[key] = { state: false, slug: c.slug };
                if (c.subCategories) build(c.subCategories, key);
            });
        };
        build(menuContent);

        // 2. wyciągamy slug-i aktywne w URL-u
        const parts = location.pathname.split('/');
        const idx = parts.indexOf('categories');
        const active = idx !== -1 ? parts.slice(idx + 1) : [];

        // 3. otwieramy wszystkie gałęzie prowadzące do aktywnych slug-ów
        Object.entries(map).forEach(([key, val]) => {
            if (active.includes(val.slug)) {
                key.split('.').filter(Boolean).reduce((acc, seg) => {
                    const path = acc ? `${acc}.${seg}` : `.${seg}`;
                    map[path].state = true;
                    return path;
                }, '');
            }
        });

        // 4. zapisujemy w stanie
        setMenuOpen(map);
    }, [menuContent, loaded, location.pathname]);

    function showMenu({ defineTopLevel, urlSegment = '', padding = '0', menuOpenId = '' }: ShowMenuRecurringArguments) {
        if (defineTopLevel.length > 0) {
            const menu = defineTopLevel?.map((topLevelItem) => {
                const idActive = menuOpen[`${menuOpenId}.${topLevelItem.categoryId}`]?.state
                // koniec rekurencji, zwróć jeśli topLevelItem nie ma dzieci w kluczu subCategories
                if (!topLevelItem.subCategories) {
                    return (
                        <div className={`mt-1 ms-${padding}`} >
                            <Link
                                id={menuOpenId + '.' + topLevelItem.categoryId?.toString()}
                                to={`/categories/${urlSegment}/${topLevelItem.slug}`}
                                className="text-break text-wrap"
                            >
                                <i className='bi-arrow-right-square ms-1 me-2 text-secondary'></i>
                                <strong>
                                    <small className={idActive ? 'text-black' : 'text-secondary'}>
                                        {topLevelItem.name}
                                    </small>
                                </strong>
                            </Link>
                        </div>
                    )
                } else if (topLevelItem.categoryId && topLevelItem.categoryId !== null) {
                    return (
                        <div className={`mt-1 ms-${padding}`} >
                            <Link
                                id={menuOpenId + '.' + topLevelItem.categoryId?.toString()}
                                to={`/categories/${urlSegment}/${topLevelItem.slug}`}
                                // onClick={(e) => togglePath(e.currentTarget.id, topLevelItem.slug)}
                                className="text-wrap text-break"
                            >
                                <i className='bi-arrow-down-square ms-1 me-2 text-secondary'></i>
                                <strong>
                                    <small className={idActive ? 'text-black' : 'text-secondary'}>
                                        {topLevelItem.name}
                                    </small>
                                </strong>
                            </Link>
                            <Collapse in={idActive} className="p-0">
                                <div>
                                    {showMenu({ defineTopLevel: topLevelItem.subCategories, urlSegment: urlSegment + "/" + topLevelItem.slug, padding: '3', menuOpenId: menuOpenId + '.' + topLevelItem.categoryId.toString() })}
                                </div>
                            </Collapse>
                        </div>
                    )
                }
            })
            return menu
        } else return null
    }

    return (
        <Navbar expand="xl" className="text-start px-1">
            <Navbar.Toggle
                aria-controls="categoriesMenu"
                aria-expanded="false"
                aria-label="Toggle navigation"
                className="w-100 py-2 my-1 mx-2 bg-success text-white rounded-3 collapsed"
            >
                <span className="bi-list fs-5">
                    <small className="ps-2">Kategorie / Wyszukaj </small>
                </span>
            </Navbar.Toggle>
            <Navbar.Collapse id="categoriesMenu" className="flex-column mx-2 mx-xl-0 align-items-start">
                {loaded && showMenu({ defineTopLevel: menuContent })}
            </Navbar.Collapse>
        </Navbar>
    )
}